import styled from "styled-components";

import { MapLibreMapHost } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

/** Fills the drawer below the address field, with the gap the Google map carried inline. */
export const AddressBlockMapStyled = styled(
  MapLibreMapHost,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "address-block-map",
})`
  height: 100%;
  width: 100%;
  margin-top: 20px;
`;
